import * as z from "zod";
import { runDetailSchema } from "./common";

export const getRun = {
  name: "getRun" as const,
  input: z.object({ runId: z.string() }),
  output: z.object({ run: runDetailSchema }),
};
